import { useQuery } from '@tanstack/react-query';
import { fetchThirdPartyInvoiceableDealers } from '../services/thirdPartyAgreement';
import { thirdPartyAgreementKeys } from './thirdPartyAgreementKeys';

export function useThirdPartyInvoiceableDealersQuery(vrm: string, reference: string, enabled: boolean) {
    return useQuery({
        queryKey: thirdPartyAgreementKeys.invoiceableDealers(vrm, reference),
        queryFn: () => fetchThirdPartyInvoiceableDealers(vrm, reference),
        enabled: enabled && vrm !== '' && reference !== '',
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
}
